import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Card, Space } from 'antd'
import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

const TaskRewardsContainer = () => {
  const location = useLocation()

  const getNavBarTitle = () => {
    const pathName = location.pathname
    if (pathName.match(/^\/task-rewards\/[0-9]+\/edit$/)) {
      return translate('navBar.editTaskRewards')
    }

    if (pathName.match(/^\/task-rewards\/new/)) {
      return translate('navBar.newTaskRewards')
    }

    if (pathName.match(/^\/task-rewards\/[0-9]+$/)) {
      return translate('navBar.viewTaskRewards')
    }

    return translate('navBar.taskRewardsTitle')
  }

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

export default TaskRewardsContainer
